/**
 * Program 12.1 UX3 — Early-pursuit attention for leads.
 */
import type { PursuitAttentionItem } from './pursuitWorkspaceModel';

function asStr(v: unknown): string {
  return v == null ? '' : String(v).trim();
}

export function buildLeadAttention(lead: Record<string, unknown>): PursuitAttentionItem[] {
  const items: PursuitAttentionItem[] = [];
  const status = asStr(lead.lead_status).toLowerCase();

  if (!lead.next_follow_up_date && !lead.is_converted && status !== 'lost' && status !== 'unqualified') {
    items.push({
      id: 'lead-no-next-action',
      severity: 'warning',
      title: 'No next action scheduled',
      detail: 'Set a follow-up date or log an activity.',
    });
  }

  if (!asStr(lead.contact_person) && !asStr(lead.email) && !lead.is_converted) {
    items.push({
      id: 'lead-no-contact',
      severity: 'info',
      title: 'Primary contact not identified',
    });
  }

  const value = Number(lead.estimated_project_value ?? lead.annual_revenue ?? 0);
  if (!value && !lead.is_converted && status === 'qualified') {
    items.push({
      id: 'lead-no-value',
      severity: 'info',
      title: 'Value not established',
      detail: 'Indicative value helps pipeline prioritization.',
    });
  }

  if (lead.next_follow_up_date) {
    const due = new Date(String(lead.next_follow_up_date).slice(0, 10));
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (due < today && !lead.is_converted) {
      items.push({
        id: 'lead-follow-up-overdue',
        severity: 'critical',
        title: 'Next action overdue',
        detail: `Follow-up was due ${String(lead.next_follow_up_date).slice(0, 10)}`,
      });
    }
  }

  return items;
}
